"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = race;
function race(iterable) {
  return Promise.race(iterable);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/awaity/esm/race.js
// module id = 1645
// module chunks = 0